/* globals Mixcloud */

import React from "react"
import { StudioManager } from "../../studio-manager";

export class MixcloudWidget extends React.Component {
  constructor () {
    super();
    this.state = { tags: [] };
  }

  componentDidMount () {
    StudioManager.instance.widget = this;
  }

  play (feed) {
    StudioManager.instance.stopAirtime();

    const url = 'https://www.mixcloud.com/widget/iframe/?mini=1&hide_cover=1&light=1&autoplay=1&feed=' + encodeURIComponent(feed);
    
    while (this.refs.container.firstChild) this.refs.container.firstChild.remove();

    // make the frame
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.allowFullscreen = true;
    iframe.scrolling = 'no';
    iframe.frameBorder = 0;
    iframe.width = '100%';
    iframe.height = 60;
    
    this.refs.container.append(iframe);
  }

  stop = () => {
    this.refs.container.innerHTML = '';
  }

  widgetReady = () => {
    
  }

  render = () => (
    <div className="mixcloud-widget__container" ref="container">
      
    </div>
  )
}


//<iframe ref={_ => this.dom = _} width={window.innd} height="60" src="https://www.mixcloud.com/widget/iframe/?mini=1&hide_cover=1&light=1&feed=%2FKioskRadio%2Fjeunesse-cosmique-kiosk-radio-15062019%2F" frameborder="0" className="mixcloud-widget" scrolling="no" />;